import HomeHero from "./HomeHero/HomeHero";
import HomeSocis from "./HomeSocis/HomeSocis";
import HomeAgenda from "./HomeAgenda/HomeAgenda";
import HomeNews from "./HomeNews/HomeNews";
import Participa from "../../components/Participa/Participa";

import "./Home.css";

function Home() {
  return (
    <div className="home">
      <HomeHero />
      <HomeSocis />
      <HomeAgenda />
      <HomeNews />
      <Participa />
      {/* Aquí afegirem la resta de seccions:
      <HomeEntities />
      <HomeBotiga /> 
      */}
    </div>
  );
}

export default Home;
